import $api from 'http'

export function getIntegrationRecords(resource, params = {}) {
  return $api.get('/integrations/v1/' + resource + '/', { params })
}
